import AuthenticatedLayout from '../../components/AuthenticatedLayout'
import { Link, usePage } from '@inertiajs/react'
import { useState } from 'react'

function formatCurrency(amount) {
  return new Intl.NumberFormat('sv-SE', { style: 'currency', currency: 'SEK' }).format(amount || 0)
}

function CopyButton({ url }) {
  const [copied, setCopied] = useState(false)

  function handleCopy() {
    navigator.clipboard.writeText(url).then(() => {
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    })
  }

  return (
    <button
      onClick={handleCopy}
      className="text-sm text-gray-500 hover:text-gray-700 border border-gray-200 rounded px-2 py-0.5 hover:bg-gray-50 transition-colors"
    >
      {copied ? 'Kopierad!' : 'Kopiera butikslänk'}
    </button>
  )
}

export default function Index({ stores }) {
  const { auth } = usePage().props

  return (
    <AuthenticatedLayout>
      <div className="space-y-6">
        <h1 className="text-2xl font-bold text-gray-900">Mina försäljningar</h1>

        {auth.user?.org_admin && (
          <div className="bg-blue-50 border border-blue-200 rounded-xl px-4 py-3 text-sm text-blue-800">
            Vill du sälja själv? Lägg till dig i ett lag via lagets
            inbjudningslänk.{" "}
            <Link
              href="/teams"
              className="font-medium underline hover:text-blue-900"
            >
              Gå till lag
            </Link>{" "}
            och välj ett lag för att skapa eller kopiera en inbjudningslänk.
          </div>
        )}

        <div className="bg-blue-50 border border-blue-200 rounded-xl px-4 py-3 text-sm text-blue-800">
          Dela din butikslänk med dina kunder så att de kan lägga beställningar
          direkt. Varje aktivitet har en unik länk som är kopplad till dig.
        </div>

        <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
          {stores.length === 0 ? (
            <p className="px-4 py-8 text-center text-gray-500 text-sm">
              Du är inte kopplad till några aktiviteter ännu.
            </p>
          ) : (
            <table className="w-full text-left">
              <thead className="bg-gray-50 text-xs text-gray-500 uppercase tracking-wide">
                <tr>
                  <th className="px-4 py-3">Aktivitet</th>
                  <th className="px-4 py-3">Lag</th>
                  <th className="px-4 py-3">Beställningar</th>
                  <th className="px-4 py-3">Totalt</th>
                  <th className="px-4 py-3"></th>
                  <th className="px-4 py-3"></th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {stores.map((store) => (
                  <tr key={store.id}>
                    <td className="px-4 py-3 text-sm text-gray-900">
                      {store.activity_name}
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-500">
                      {store.team_name}
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-500">
                      {store.orders_count}
                    </td>
                    <td className="px-4 py-3 text-sm font-medium text-gray-900">
                      {formatCurrency(store.total_sales)}
                    </td>
                    <td className="px-4 py-3 text-sm">
                      <Link
                        href={`/stores/${store.id}/orders`}
                        className="text-indigo-600 hover:underline"
                      >
                        Beställningar
                      </Link>
                    </td>
                    <td className="px-4 py-3 text-sm flex items-center gap-4 justify-end">
                      <CopyButton
                        url={`${window.location.origin}/stores/${store.token}`}
                      />
                      <div className="flex items-center gap-2">
                        <a
                          href={`/stores/${store.token}`}
                          target="_blank"
                          rel="noreferrer"
                          className="text-sm text-indigo-600 hover:underline"
                        >
                          Visa butik →
                        </a>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </AuthenticatedLayout>
  );
}
